import {
    convertDateToFields,
    convertDateToLocalString,
    convertDateWithLocalTimeZone,
    getLocalTimeZoneName
} from "./shared/functions";

/**
 * Post-Process incoming list or item data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 *
 * @return {*}
 */
export const postProcessData = (resource, type, params, rdata) => {

    if (resource === 'Locations') {
        if (type === 'GET_LIST') {
            if (params && params.id) {
                rdata = processLocationsByIdData(rdata);
            }
        }
        if (type === 'GET_ONE') {
            rdata = processLocationData(rdata);
        }
    }
    if (resource === 'Discounts') {
        if (type === 'GET_LIST') {
            rdata = processDiscountsData(rdata);
        }
        if (type === 'GET_ONE') {
            rdata = processDiscountData(rdata);
        }
    }
    if (resource === 'LocationNames') {
        if (type === 'GET_LIST') {
            rdata = processLocationNamesListData(rdata);
        }
        if (type === 'GET_ONE') {
            rdata = processLocationNameData(rdata);
        }
    }
    if (resource === 'LocationsForInventory' && type === 'GET_LIST') {
        rdata = processLocationsForInventoryListData(rdata);
    }
    if (resource === 'DBAs') {
        if (type === 'GET_ONE') {
            rdata = processDbaData(rdata);
        }
    }
    if (resource === 'AdditionalTaxes') {
        if (type === 'GET_LIST') {
            rdata = processAdditionalTaxesListData(rdata);
        }
        if (type === 'GET_ONE') {
            rdata = processAdditionalTaxData(rdata);
        }
    }
    if (resource === 'Products' && type === 'GET_LIST') {
        rdata = processProductsListData(rdata);
    }
    if (resource === 'ProductCategories' && type === 'GET_ONE') {
        rdata = processEditProductCategoryData(rdata);
    }
    if (resource === 'ProductUnits' && type === 'GET_ONE') {
        rdata = processEditProductUnitData(rdata);
    }
    if (resource === 'ProductUnitCreate') {
        rdata = processCreateProductUnitData(rdata);
    }
    if (resource === 'ProductAliases') {
        if (type === 'GET_LIST') {
            rdata = processProductAliasListData(rdata);
        }
        if (type === 'GET_ONE') {
            rdata = processProductAliasData(rdata);
        }
    }
    if (resource === 'InventoryTransferAudits') {
        rdata = processInventoryTransferAuditData(rdata);
    }
    if (resource === 'InventoryTransferContents') {
        rdata = processIncomingTransferData(rdata, params);
    }
    if (resource === 'InventoryRepacksRetailBoxes') {
        if (type === 'GET_LIST') {
            rdata = processRepackRetailBoxListData(rdata);
        }
        if (type === 'GET_ONE') {
            rdata = processRepackRetailBoxData(rdata);
        }
    }
    if (resource === 'VipCardConfigurations') {
        if (type === 'GET_LIST') {
            rdata = processVipCardConfigListData(rdata, params);
        }
        if (type === 'GET_ONE') {
            rdata = processVipCardConfigData(rdata, params);
        }
    }
    if (resource === 'LoyaltyAccounts') {
        if (type === 'GET_ONE') {
            rdata = processLoyaltyAccountData(rdata);
        }
    }
    if (resource === 'POSUsers' && type === 'GET_LIST') {
        rdata = processPOSUserData(rdata, params);
    }
    if (resource === 'POSKits') {
        if (type === 'GET_LIST') {
            rdata = processPOSKitListData(rdata, params);
        }
        if (type === 'GET_ONE') {
            rdata = processPOSKitData(rdata, params);
        }
    }
    return rdata;
};

/**
 * Post-Process data after upsert
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 * @param ack
 * @return {*}
 */
export const postProcessUpsertData = (resource, type, params, rdata, ack) => {
    if (
        (resource === 'AdditionalTaxes' && (type === 'CREATE' || type === 'UPDATE')) ||
        (resource === 'InventoryTransfers' && type === 'CREATE')
    ) {
        if (ack && ack.success === true) {
            return true;
        }
    }
    return rdata;
};

/* Location Processing ::::: */

/**
 * Process Locations data by artificially populating a list
 */
const processLocationsByIdData = (rdata) => {
    rdata.data = [rdata.data];
    rdata.ids = [rdata.data[0].id];
    rdata.payload_meta = {total: 1};
    rdata.total = 1;
    return rdata;
};

/**
 * Process single Location data
 *
 * @param rdata
 */
const processLocationData = (rdata) => {
    // Convert special character to breaks
    let receiptMsg = rdata.data.receipt_message;
    if (receiptMsg) {
        receiptMsg = stripTags(receiptMsg);
        receiptMsg = receiptMsg.replace(/(?:&br;)/g, '\n');
        rdata.data.receipt_message = receiptMsg;
    } else {
        rdata.data.receipt_message = '';
    }
    if (!rdata.data.display_receipt_message) {
        rdata.data.display_receipt_message = false;
    }

    return rdata;
};

/**
 * Process Location (Name) data after retrieval
 */
const processLocationNameData = (rdata) => {
    // Add props for Edit/Delete form
    rdata.data.id = rdata.data.id.toString();
    return rdata;
};

/**
 * Process multiple Location (Name) data after retrieval
 */
const processLocationNamesListData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }
    // Convert Location ID values for Edit/Delete form
    rdata.data.forEach(function (loc, idx) {
        loc.id = loc.id.toString();
    });
    return rdata;
};

/**
 * Process multiple Inventory Locations data after retrieval
 */
const processLocationsForInventoryListData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }
    rdata.data.forEach(function (loc, idx) {
        const id = (loc.id) ? loc.id.toString() : '';
        const name = (loc.name) ? ' - ' + loc.name.toString() : '';
        const city = (loc.city) ? ' - ' + loc.city.toString() : '';
        const state = (loc.state) ? ' - ' + loc.state.toString() : '';
        loc.filter_name = id + name + city + state;
    });
    return rdata;
};

/**
 * Process single DBA data
 *
 * @param rdata
 * @return {*}
 */
const processDbaData = (rdata) => {
    // Convert special character to breaks
    let receiptMsg = rdata.data.receipt_message;
    if (receiptMsg) {
        receiptMsg = stripTags(receiptMsg);
        receiptMsg = receiptMsg.replace(/(?:&br;)/g, '\n');
        rdata.data.receipt_message = receiptMsg;
    } else {
        rdata.data.receipt_message = '';
    }

    return rdata;
};

const processAdditionalTaxesListData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }
    rdata.data.forEach(function (at, idx) {
        at.tax_rate_percent = at.tax_rate + '%';
        at.display_name = at.name + ' - ' + at.tax_rate_percent;
        if (at.description) {
            at.display_name += ' - ' + at.description;
        }
    });
    return rdata;
};

const processAdditionalTaxData = (rdata) => {
    rdata.data.tax_rate_percent = rdata.data.tax_rate + '%';
    rdata.data.display_name = rdata.data.name + ' - ' + rdata.data.tax_rate_percent;
    if (rdata.data.description) {
        rdata.data.display_name += ' - ' + rdata.data.description;
    }
    return rdata;
};

/* Product Processing ::::: */

const processProductsListData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }
    rdata.data.forEach(function (product, idx) {
        if (!product.type || product.type === '') {
            product.type = (product.product_type) ? product.product_type : '';
        }
    });
    return rdata;
};

/**
 * Process Product Category Edit data after retrieval
 */
const processEditProductCategoryData = (rdata) => {
    if (rdata.data.parent_id) {
        rdata.data.category_id = rdata.data.parent_id.toString();
        rdata.data.current_parent_id = rdata.data.parent_id.toString();
    }
    rdata.data.current_parent_name = rdata.data.parent_name;
    return rdata;
};

/**
 * Process Product Unit Create collection data after retrieval
 */
const processCreateProductUnitData = (rdata) => {
    rdata.data.product_id = rdata.data.id.toString();
    rdata.data.units_per_scan_piece = '1';
    rdata.data.price = {};
    rdata.data.price.default = '0';
    rdata.data.price.hidden = '0.01';
    return rdata;
};

/**
 * Process Product Unit Edit collection data after retrieval
 */
const processEditProductUnitData = (rdata) => {
    rdata.data.units_per_scan_piece = '1';
    rdata.data.current_product_id = rdata.data.product_id;
    if (!rdata.data.default_unit && !rdata.data.piece_unit) {
        rdata.data.piece_unit = '(None)';
    }
    if (rdata.data.default_unit && !rdata.data.piece_unit) {
        rdata.data.piece_unit = '(Self)';
    }
    return rdata;
};

/**
 * Process Alias list data after retrieval
 */
const processProductAliasListData = (rdata) => {
    rdata.data.id = rdata.data.sku;
    return rdata;
};

/**
 * Process Alias data after retrieval
 */
const processProductAliasData = (rdata) => {
    if (rdata.data.product_unit_id) {
        rdata.data.current_product_unit_id = rdata.data.product_unit_id.toString();
    }
    return rdata;
};

/**
 * Process multiple Discounts data after retrieval
 */
const processDiscountsData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }

    const tzName = getLocalTimeZoneName();

    rdata.data.forEach(function (discount, idx) {
        const validFromDate = new Date(discount.valid_from);
        const validToDate = new Date(discount.valid_to);
        const fromFields = convertDateToFields(validFromDate);
        const toFields = convertDateToFields(validToDate);
        const validFromString = convertDateWithLocalTimeZone(validFromDate, false);
        const validToString = convertDateWithLocalTimeZone(validToDate, false);

        discount.valid_from_date = validFromDate;
        discount.valid_from_string = discount.valid_from.substring(0, 10);
        discount.valid_from_hour = fromFields.hour;
        discount.valid_from_min = fromFields.min;
        discount.valid_from_ampm = fromFields.ampm;
        discount.valid_from_tz = validFromString + ' ' + tzName;

        discount.valid_to_date = validToDate;
        discount.valid_to_string = discount.valid_to.substring(0, 10);
        discount.valid_to_hour = toFields.hour;
        discount.valid_to_min = toFields.min;
        discount.valid_to_ampm = toFields.ampm;
        discount.valid_to_tz = validToString + ' ' + tzName;
    });
    return rdata;
};

/**
 * Process Discount data after retrieval
 * Will eventually convert and display local and time zone data
 */
const processDiscountData = (rdata) => {
    const tzName = getLocalTimeZoneName();

    const validFromDate = new Date(rdata.data.valid_from);
    const validToDate = new Date(rdata.data.valid_to);
    const fromFields = convertDateToFields(validFromDate);
    const toFields = convertDateToFields(validToDate);
    const validFromString = convertDateWithLocalTimeZone(validFromDate, false);
    const validToString = convertDateWithLocalTimeZone(validToDate, false);

    // Add props for Edit form
    rdata.data.valid_from_date = validFromDate;
    rdata.data.valid_from_string = rdata.data.valid_from.substr(0, 10);
    rdata.data.valid_from_hour = fromFields.hour;
    rdata.data.valid_from_min = fromFields.min;
    rdata.data.valid_from_ampm = fromFields.ampm;
    rdata.data.valid_from_tz = validFromString + ' ' + tzName;

    rdata.data.valid_to_date = validToDate;
    rdata.data.valid_to_string = rdata.data.valid_to.substr(0, 10);
    rdata.data.valid_to_hour = toFields.hour;
    rdata.data.valid_to_min = toFields.min;
    rdata.data.valid_to_ampm = toFields.ampm;
    rdata.data.valid_to_tz = validToString + ' ' + tzName;

    return rdata;
};

/* Inventory Processing ::::: */

/**
 * Process Inventory Transfer Audit collection data after retrieval
 *
 * @param rdata
 * @return {*}
 */
const processInventoryTransferAuditData = (rdata) => {
    const tzName = getLocalTimeZoneName();
    const receivedDate = new Date(rdata.data.received_date);
    const receivedString = convertDateWithLocalTimeZone(receivedDate, false);
    rdata.data.id = rdata.data.transfer_id;
    rdata.data.received_tz = receivedString + ' ' + tzName;
    return rdata;
};

/**
 * Process Incoming Transfer collection data after retrieval
 *
 * @param rdata
 * @param params
 * @return {*}
 */
const processIncomingTransferData = (rdata, params) => {
    const contents = rdata.data;
    rdata.data = {};
    rdata.data.location_to = params.location_id;
    rdata.data.transfer_id = params.transfer_id;
    rdata.data.contents = contents;
    return rdata;
};

/**
 * Process Repack or Retail Box collection data after retrieval
 *
 * @param rdata
 * @return {*}
 */
const processRepackRetailBoxListData = (rdata) => {
    // If the return is a singleton, format it as an array with IDs and total
    if (!rdata.data.length) {
        const dataObj = rdata.data;
        dataObj.id = dataObj.inv_collection_model.collection_id;
        rdata.data = [];
        rdata.data.push(dataObj);
        rdata.ids = [];
        rdata.ids.push(dataObj.id);
        rdata.total = 1;
    }
    return rdata;
};

const processRepackRetailBoxData = (rdata) => {
    const tzName = getLocalTimeZoneName();
    const modifiedDate = new Date(rdata.data.inv_collection_model.modified);
    const modifiedString = convertDateWithLocalTimeZone(modifiedDate, false);

    rdata.data.collection_id = rdata.data.inv_collection_model.collection_id.toString();
    rdata.data.collection_type = rdata.data.inv_collection_model.collection_type;
    rdata.data.contents = rdata.data.inv_collection_model.contents;
    rdata.data.created_by_client = rdata.data.inv_collection_model.created_by_client;
    rdata.data.mode = rdata.data.inv_collection_model.mode;
    rdata.data.modified = rdata.data.inv_collection_model.modified;
    rdata.data.modified_tz = modifiedString + ' ' + tzName;
    rdata.data.system = rdata.data.inv_collection_model.system;
    return rdata;
};

/* Loyalty Account Processing ::::: */

/**
 * Process multiple VIP Card Configurations data after retrieval
 */
const processVipCardConfigListData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }
    // Convert Start/End Ranges to six-character strings for List
    rdata.data.forEach(function (item, idx) {
        const start = '000000' + item.range_start.toString();
        const end = '000000' + item.range_end.toString();
        item.range_start_string = start.slice(-6);
        item.range_end_string = end.slice(-6);
    });
    return rdata;
};

/**
 * Process VIP Card Configuration data after retrieval
 */
const processVipCardConfigData = (rdata) => {
    // Convert Start/End Ranges to six-character strings for Edit
    const start = '000000' + rdata.data.range_start.toString();
    const end = '000000' + rdata.data.range_end.toString();
    rdata.data.range_start_string = start.slice(-6);
    rdata.data.range_end_string = end.slice(-6);
    return rdata;
};

/**
 * Process Loyalty Account data after retrieval
 */
const processLoyaltyAccountData = (rdata) => {
    rdata.data.id = rdata.data.customer.id.toString();
    rdata.data.active = rdata.data.customer.active;
    rdata.data.address_1 = rdata.data.customer.address_1;
    rdata.data.address_2 = rdata.data.customer.address_2;
    rdata.data.city = rdata.data.customer.city;
    rdata.data.country = rdata.data.customer.country;
    rdata.data.email = rdata.data.customer.email;
    rdata.data.first_name = rdata.data.customer.first_name;
    rdata.data.last_name = rdata.data.customer.last_name;
    rdata.data.notes = rdata.data.customer.notes;
    rdata.data.state = rdata.data.customer.state;
    rdata.data.telephone = rdata.data.customer.telephone;
    rdata.data.zip = rdata.data.customer.zip;
    rdata.data.fraud_lock = rdata.data.customer.fraud_lock;
    rdata.data.temp_lock = rdata.data.customer.temp_lock;
    rdata.data.override_locks = rdata.data.customer.override_locks;
    rdata.data.activation_hash = rdata.data.customer.activation_hash;
    rdata.data.registered_by_client = rdata.data.customer.registered_by_client;
    rdata.data.registration_date = rdata.data.customer.registration_date;
    rdata.data.registration_location = rdata.data.customer.registration_location;
    rdata.data.current_rank_points = rdata.data.rank_points;
    rdata.data.current_reward_points = rdata.data.reward_points;
    rdata.data.rank_points = 0;
    rdata.data.reward_points = 0;
    rdata.data.modified_local_str = convertDateToLocalString(rdata.data.customer.modified);
    return rdata;
};

/**
 * Process POS User data after retrieval with possible data manipulation
 *
 * @param rdata
 * @param params
 * @return {*}
 */
const processPOSUserData = (rdata, params) => {
    if (params.filter) {
        if (!params.filter.filter_active) {
            params.filter.filter_active = 'all';
        }
    }
    let active = params.filter.filter_active;
    // If filtered, remove elements from data and ids lists
    if (active === 'active' || active === 'inactive') {
        let newData = [];
        let newIds = [];
        let keepValue = (active === 'active');
        for (let i = 0; i < rdata.data.length; i++) {
            let item = rdata.data[i];
            if (item.active === keepValue) {
                newData.push(item);
                newIds.push(item.id);
            }
        }

        rdata.data = [];
        rdata.data = newData;
        rdata.ids = [];
        rdata.ids = newIds;
        rdata.total = newData.length;
    }
    return rdata;
};

/**
 * Process POS Kit list data after retrieval
 */
const processPOSKitListData = (rdata) => {
    // If the return is a singleton, format it as an array with IDs and total
    if (!rdata.data.length) {
        const dataObj = rdata.data;
        dataObj.id = dataObj.kit_id;
        rdata.data = [];
        rdata.data.push(dataObj);
        rdata.ids = [];
        rdata.ids.push(dataObj.id);
        rdata.total = 1;
    } else {
        rdata.data.forEach(function (item, idx) {
            item.id = item.kit_id;
        });
    }

    return rdata;
};

/**
 * Process POS Kit data after retrieval
 */
const processPOSKitData = (rdata) => {
    rdata.data.id = rdata.data.kit_id;

    return rdata;
};

/* ID and Key exported functions ::::: */

/**
 * Mark resources without ids or with different unique identifiers
 */
export const setUniqueKeys = (resource) => {
    const parseParams = {
        hasNameKeys: false,
        needsId: false,
        parentKey: null,
        idKey: null
    };
    if (resource === 'AdditionalTaxes') {
        parseParams.idKey = 'machine_name';
    }
    if (resource === 'PriceLevels') {
        parseParams.hasNameKeys = true;
    }
    if (resource === 'LocationInventory') {
        parseParams.needsId = true;
    }
    if (resource === 'ProductAliases') {
        parseParams.idKey = 'sku';
    }
    if (resource === 'InventoryRepacksRetailBoxes') {
        parseParams.parentKey = 'inv_collection_model';
        parseParams.idKey = 'collection_id';
    }
    if (
        resource === 'InventoryTransfers' ||
        resource === 'InventoryTransferContents' ||
        resource === 'InventoryTransferAudits' ||
        resource === 'TransferredProducts'
    ) {
        parseParams.idKey = 'transfer_id';
    }
    if (resource === 'POSUserTypes') {
        parseParams.needsId = true;
    }
    if (resource === 'LoyaltyIncentiveTiers') {
        parseParams.idKey = 'min_dollars';
    }
    if (resource === 'VipCardConfigurations') {
        parseParams.idKey = 'prefix';
    }
    if (resource === 'LoyaltyAccounts') {
        parseParams.idKey = 'id';
    }
    if (resource === 'LoyaltyAccountLogs') {
        parseParams.idKey = 'uuid';
    }
    if (resource === 'Configurations') {
        parseParams.idKey = 'name';
    }
    return parseParams;
};

/* Miscellaneous functions ::::: */

const stripTags = (str) => {
    return str.replace(/(<([^>]+)>)/ig, '');
};



// WEBPACK FOOTER //
// ./src/Fuse/restClientPostProcess.js